import '../styles/App.css';

import { useScrollReveal } from '../hooks/useScrollReveal.js';

import { NavMain } from './NavMain.jsx';
import { Home } from './Home.jsx';
import { AboutMe } from './AboutMe.jsx';
import { Services } from './Services.jsx';
import { Skills } from './Skills.jsx';
import { Projects } from './Projects.jsx';
import { Experience } from './Experience.jsx';
import { Education } from './Education.jsx';
import { Contact } from './Contact.jsx';
import { Footer } from './Footer.jsx';

// Animaciones: van al final para que ganen a los estilos de cada sección
import '../styles/Motion.css';

function App() {
  useScrollReveal();

  return(
    <div className="App">

      <NavMain />
      <Home />
      <AboutMe />
      <Services />
      <Skills />
      <Projects />
      <Experience />
      <Education />
      <Contact />
      <Footer />

    </div>
  );
}

export default App;